import { useMemo } from "react";
import { hasCapability } from "@vninvestcharts/engine-core";
import { useFeatureGate } from "../hooks/useFeatureGate";
export function useTierGatedFeatures(tier, options) {
    const { checkFeature } = useFeatureGate();
    const narrowing = options?.narrowing;
    const flags = useMemo(() => ({
        isWhalePanelEnabled: checkFeature("isWhalePanelEnabled"),
        isReplayEnabled: checkFeature("isReplayEnabled"),
        isAdvisoryEnabled: checkFeature("isAdvisoryEnabled"),
        hideTrademark: checkFeature("hideTrademark"),
        showWidgetAds: checkFeature("showWidgetAds"),
    }), [checkFeature]);
    return useMemo(() => {
        const allowList = narrowing && narrowing.length > 0 ? new Set(narrowing) : null;
        // Ba điều kiện: tier đủ + không bị license thu hẹp.
        const allows = (capability) => hasCapability(tier, capability) && (!allowList || allowList.has(capability));
        return {
            canUseReplay: allows("replay") && flags.isReplayEnabled,
            // Community: paper market/limit luôn mở (Rule 15) — nhưng vẫn tôn trọng
            // `caps` của license nếu license cố ý thu hẹp.
            canUsePaperMarketLimit: allows("paper_market_limit"),
            canUsePaperAdvanced: allows("paper_advanced"),
            canUsePineEditor: allows("pine_editor"),
            canUseStrategyTester: allows("strategy_tester"),
            allows,
        };
    }, [tier, flags, narrowing]);
}
